import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=cb30b190"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports